import { cn } from "@/lib/utils";

import { Kbd } from "./Kbd";

/**
 * A keyboard shortcut as a row of keycaps, e.g. `["Shift", "7"]`.
 *
 * Write keys the way the user's keyboard prints them, in press order. Key
 * names are not translated — a modifier is the legend on the physical key, not
 * a word in a sentence — so a shortcut needs no locale entry. Anything that
 * needs a sentence around it ("Open with …") belongs at the call site.
 */
export const Shortcut = ({
  keys,
  className,
}: {
  keys: string[];
  className?: string;
}) => (
  <span className={cn("inline-flex items-center gap-x-1", className)}>
    {keys.map((key) => (
      <Kbd key={key}>{key}</Kbd>
    ))}
  </span>
);
